import { Link } from "react-router-dom";
import { StatusLine } from "../components/StatusLine";
import { useIcps } from "../hooks/useIcps";
import { formatTime } from "../lib/format";

export function Icps() {
  const { data, isLoading, isError, error } = useIcps({ includeInactive: true });

  return (
    <section className="card">
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          gap: 16,
        }}
      >
        <div>
          <h2 style={{ marginTop: 0 }}>ICPs</h2>
          <p className="card-desc">
            Every ICP in the catalog. Edit prompts, scoring rubric, Apollo
            filters, and the Lemlist campaign for each.
          </p>
        </div>
        <Link to="/icps/new" className="button-link">
          + New ICP
        </Link>
      </div>

      {isLoading && <StatusLine variant="running" message="Loading…" />}
      {isError && (
        <StatusLine
          variant="error"
          message={`Failed to load: ${error?.message ?? "unknown"}`}
        />
      )}

      {data && data.length === 0 && (
        <StatusLine variant="idle" message="No ICPs configured." />
      )}

      {data && data.length > 0 && (
        <div className="result">
          {data.map((icp) => (
            <div key={icp.name} className="contact">
              <div className="contact-top">
                <div>
                  <div className="contact-name">{icp.display_name}</div>
                  <code className="contact-company">{icp.name}</code>
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <Link to={`/icps/${icp.name}/improve`} className="button-link">
                    Improve prompt
                  </Link>
                  <Link to={`/icps/${icp.name}`} className="button-link">
                    Edit
                  </Link>
                </div>
              </div>
              <div className="chip-row">
                <span className={`chip ${icp.is_active ? "chip-on" : "chip-off"}`}>
                  {icp.is_active ? "Active" : "Inactive"}
                </span>
                <span className="chip">Min score {icp.min_score}</span>
                <span className="chip">
                  Lemlist: {icp.lemlist_campaign_id ?? "—"}
                </span>
                <span className="chip">
                  Updated {formatTime(icp.updated_at)}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}
